/**
 * @documental
 * @export useSimpleInputState
 * @type
 * hook
 * @import
 * import { useSimpleInputState } from "capitalrx-components-2.0/lib/forms";
 */

import { useCallback, useState } from "react";
import { InputChangeHandler } from "./InputChangeHandler";

/**
 * Uses simple in-memory input state management, providing the current value and a value change handler.
 * @param initialValue The initial input value.
 * @returns A tuple containing the current value and input change handler function.
 */
export function useSimpleInputState<TValue>(initialValue?: TValue): [TValue | undefined, InputChangeHandler<TValue>] {
  const [value, setValue] = useState<TValue | undefined>(initialValue);

  const changeHandler = useCallback<InputChangeHandler<TValue>>((value) => {
    setValue(value);
  }, []);

  return [value, changeHandler];
}
